import * as local from './local-storage';
import * as memory from './memory-storage';

function hasLocalStorage() {
    var test = 'test';

    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);

        return true;
    } catch (e) {
        return false;
    }
}

// test according to modernizr
// https://github.com/Modernizr/Modernizr/blob/master/feature-detects/json.js
function hasJson() {
    return 'JSON' in window && 'parse' in JSON && 'stringify' in JSON;
}

export function getStorage() {
    let storage = memory;

    // return based on browser capability
    if (hasLocalStorage() && hasJson()) {
        storage = local;
    }

    return storage;
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/helpers/storage-factory.js
 **/